import { useCallback } from 'react';
import { useAsync } from './useAsync';
import { listCampaigns, getCampaign } from '@/services/campaigns';
import type { Campaign } from '@/types/api';

export function useCampaigns(offset = 0, limit = 50) {
  const fn = useCallback(() => listCampaigns(offset, limit), [offset, limit]);
  return useAsync<Campaign[]>(fn);
}

export function useCampaign(id: number | null) {
  const fn = useCallback(
    () => (id != null ? getCampaign(id) : Promise.reject(new Error('No ID'))),
    [id],
  );
  return useAsync<Campaign>(id != null ? fn : null);
}
